import React, { Component } from 'react';

class CaseSubmitted extends Component {
  render() {
    return (
      <div
        className="modal fade theme-modal" id="caseSubmittedModal"
        tabIndex="-1"
        aria-labelledby="caseSubmittedModalLabel" aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="caseSubmittedModalLabel">Case Submitted</h5>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CaseSubmitted;
